import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        offices: [],
    }
}

const getters = {
    offices: state => state.offices,
};

const actions = {
    fetchOffices({commit}, type = 'arrival') {
        Http.get(API_URL + VERSION + '/arrival-offices', {
            params: {
                type
            }
        })
            .then(response => {
                commit('setOffices', response.data)
            })
    }
};

const mutations = {
    setOffices(state, items) {
        state.offices = items
    },
};

export default {
    state: initialState,
    getters,
    actions,
    mutations
}
